module.exports = {

    props: {
        language: String
    },

    data() {
        return {
            localization_keys: [],
            translations: {},
            localization_loaded: false
        }
    },

    created: function() {
        this.localize(this.localization_keys);
    },

    methods: {
        localize: function (keys) {
            if (keys.length > 0)
            {
                var url = 'language/get';

                this.$http.get(url, {
                    params: {
                        key: keys
                    }
                }).then(function (response) {
                    var self = this;
                    $.each(response.data, function(key, value) {
                        if (value != null && typeof value === 'object') {
                            if (!self.translations[key]) Vue.set(self.translations, key, {});
                            $.each(value, function (k, v) {
                                Vue.set(self.translations[key], k, v);
                            });
                        }
                        else Vue.set(self.translations, key, value);
                    });

                    this.localization_loaded = true;
                });
            }
        },
        lang: function (key) {
            if (!this.translations[key]) {
                Vue.set(this.translations, key, '');
            }
            return this.translations[key];
        },
        hasKey: function (key) {
            return this.localization_keys.indexOf(key) > -1;
        }
    }

};
